const Data2 = [
    {
      titulo: "Sobre nosotros",
      lista: [
        "Nuestra historia",
        "Nuestra misión",
        "Nuestra cultura inclusiva y valores",
        "Nuestro café",
        "Historia y novedades",
        "Comunicados oficiales",
        "Trabaja con nosotros"
      ]
    },
    {
      titulo: "Impacto social",
      lista: [
        "Abastecimiento ético",
        "Sustentabilidad",
        "Inclusión, diversidad y equidad",
        "Global social impact"
      ]
    },
    {
      titulo: "Atención al cliente",
      lista: [
        "Contacto"
      ]
    },
    {
      titulo: "Experiencia Starbucks",
      lista: [
        "Formas de comprar",
        "Delivery"
      ]
    }
  ];


  export default Data2